/**
 * **envelope 保留键** —— 业务 payload 不许使用这些 key。
 *
 * [envelope] 是先展开 `extra`、再写自己的键，所以同名的业务值会被**静默覆盖** ——
 * 没有报错，只有某个字段在后台悄悄变成 envelope 的值。踩过两次（2026-08-12 同一批发现）：
 *
 * - `chat_card_view` 的业务 `scene`（卡片业务场景 chat/notification/brief）→ 改名 `card_scene`
 * - `notification_button_feedback` 的业务 `event_type`（信号类型）→ 改名 `signal_event_type`
 *
 * 撞了就给业务键加语义前缀，别指望这里让路 —— envelope 的字段是全局查询维度，不能按事件让位。
 * 与 native `analytics/Envelope.kt` 的同名常量**逐字对齐**。
 *
 * ⚠️ `scene` / `screen` / `trace_id` 是**条件覆盖**（运行时有值才写），最阴：
 * 单测里不设 scene 就看不出问题，真机上任何页面都派生得出 scene，于是线上必覆盖。
 * 所以告警在**撞键当场**发，不看 envelope 这次有没有真的写进去。
 */
export const ENVELOPE_RESERVED_KEYS: ReadonlySet<string> = new Set([
  "event_type",
  "app_run_id",
  "seq",
  "container",
  "trace_id",
  "screen",
  "scene",
  "oversize",
  "ed_device_id",
  "owner_id",
  "adjust_adid",
]);
